/**
 * Manufacturing API
 * Manufacturing API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = Manual, 1 = StationCommand, 2 = ProgramIdentity, 3 = PrintScannableCode, 4 = PrintTrackingLabel, 5 = ScanScannableCode, 6 = PickComponents
 */
export enum WizardStepKind {
    Manual = 0,
    StationCommand = 1,
    ProgramIdentity = 2,
    PrintScannableCode = 3,
    PrintTrackingLabel = 4,
    ScanScannableCode = 5,
    PickComponents = 6
}

